<template>
  <div class="appointment-history-wrapper">
    <div class="pack">
      <p class="name">
        {{ subscriber.package.name }}
      </p>
      <p class="quality mt-1">{{ subscriber.package.quality }}</p>
    </div>
    <div
      v-for="(service, serviceIndex) in services"
      :key="serviceIndex"
      class="history"
    >
      <service-item :key="service.id" v-bind="service.data"></service-item>
      <div
        v-for="(history, historyIndex) in Object.keys(
          service.histories
        ).sort((a, b) => (b.invoice > a.invoice ? 1 : -1))"
        :key="history"
      >
        <div class="billing-cycle" v-if="history !== 'null'">
          <p>
            {{
              `รอบบิลที่ ${Object.keys(service.histories).length -
                historyIndex}`
            }}
          </p>
          <div
            class="arrow-wrapper"
            @click="handleExpandBillingCycle(service.histories[history][0])"
            v-if="
              isShowExpandBillingCycleBtn(
                Object.keys(service.histories).length,
                historyIndex
              )
            "
          >
            <i
              class="arrow down"
              v-if="service.histories[history][0].isExpandBillingCycle"
            ></i>
            <i
              class="arrow up"
              v-if="!service.histories[history][0].isExpandBillingCycle"
            ></i>
          </div>
        </div>
        <div
          class="title-wrapper"
          v-if="service.histories[history][0].isExpandBillingCycle && isDesktop"
        >
          <p>ครั้งที่ :</p>
          <p>สถานะงาน :</p>
          <p>นัดหมาย :</p>
          <p>หมายเหตุลูกค้า :</p>
        </div>
        <div
          v-for="(appointment, appointmentIndex) in service.histories[history]"
          :key="appointmentIndex"
        >
          <div
            class="item"
            v-if="service.histories[history][0].isExpandBillingCycle"
          >
            <div
              :class="
                isDesktop
                  ? contentWrapperClassList(
                      appointment.constraint.canMakeAppointment
                    )
                  : 'content-wrapper'
              "
              v-if="!appointment.constraint.canMakeAppointment"
            >
              <p class="appointment-no">
                {{
                  `${
                    appointment.appointmentNo !== null
                      ? appointment.appointmentNo
                      : appointmentIndex + 1
                  }/${service.histories[history].length}`
                }}
              </p>
              <div class="status">
                <div
                  class="bullet"
                  :class="statusList(appointment.status)"
                ></div>
                <p>{{ statusText(appointment.status) }}</p>
              </div>
              <div v-if="isDesktop">
                <p :class="appointmentTimeStatusList(appointment.status)">
                  {{ appointment.date }}
                </p>
                <p
                  :class="appointmentTimeStatusList(appointment.status)"
                  v-if="!isFastFixServiceType(service.data.type)"
                >
                  {{ appointment.time }}
                </p>
              </div>
              <div v-else>
                <div class="appointment-title">นัดหมาย :</div>
                <p
                  class="appointment"
                  :class="appointmentTimeStatusList(appointment.status)"
                  v-if="!isFastFixServiceType(service.data.type)"
                >
                  {{ appointment.date }} {{ appointment.time }}
                </p>
                <p
                  :class="appointmentTimeStatusList(appointment.status)"
                  v-else
                >
                  {{ appointment.date }}
                </p>
              </div>
              <p v-if="isDesktop">{{ appointment.note }}</p>
              <div class="note" v-else>
                <div class="title">{{ "หมายเหตุลูกค้า :" }}</div>
                <p>{{ appointment.note }}</p>
              </div>
            </div>
            <div
              :class="
                isDesktop
                  ? contentWrapperClassList(
                      appointment.constraint.canMakeAppointment
                    )
                  : 'content-wrapper content-border'
              "
              v-else
            >
              <p class="appointment-no">
                {{
                  `${isDesktop ? "" : "ครั้งที่"}${
                    appointment.appointmentNo !== null
                      ? appointment.appointmentNo
                      : appointmentIndex + 1
                  }/${service.histories[history].length}`
                }}
              </p>
              <p v-if="!appointment.isDisableButton">
                ยังไม่ได้นัดหมาย
              </p>
              <p v-else>ไม่สามารถนัดหมายได้</p>
              <div
                :class="
                  buttonWrapperClassList(
                    appointment.constraint.canMakeAppointment
                  )
                "
              >
                <button
                  class="button primary"
                  :disabled="appointment.isDisableButton"
                  @click="handleClickAppoint(appointment)"
                >
                  นัดวัน
                </button>
              </div>
            </div>
            <div
              :class="
                buttonWrapperClassList(
                  appointment.constraint.canMakeAppointment
                )
              "
              v-if="!appointment.constraint.canMakeAppointment"
            >
              <button
                class="button secondary"
                @click="handleClickViewDetail(appointment.route)"
              >
                ดูข้อมูล
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceItem from "../components/ServiceItem";
import { mlSize } from "../StaticVariable";

export default {
  components: {
    ServiceItem
  },
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  props: ["subscriber", "services"],
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    isFastFixServiceType(serviceType) {
      return serviceType === "FAST_FIX";
    },
    isShowExpandBillingCycleBtn(historiesLength, historyIndex) {
      return (historiesLength > 1 && historyIndex > 0) || !this.isDesktop;
    },
    statusText(status) {
      const statusMap = {
        CREATED: "นัดใหม่",
        CANCELLED: "ยกเลิก",
        CONFIRMED: "ยืนยัน",
        WAIT_CONFIRMED_SERVICE_COMPLETE: "รอรับบริการ",
        PROVIDER_FULFILLED: "ช่างปิดงาน",
        FULFILLED: "เสร็จสิ้น"
      };

      return statusMap[status];
    },
    statusList(status) {
      return [status.toLowerCase()];
    },
    appointmentTimeStatusList(status) {
      return [`time_${status.toLowerCase()}`];
    },
    contentWrapperClassList(canMakeAppointment) {
      return [`content-wrapper-${canMakeAppointment}`];
    },
    buttonWrapperClassList(canMakeAppointment) {
      return [`button-wrapper-${canMakeAppointment}`];
    },
    handleExpandBillingCycle(selectedAppointment) {
      this.$emit("expandBillingCycle", selectedAppointment);
    },
    async handleClickAppoint(appointment) {
      this.$emit("appoint", appointment);
    },
    async handleClickViewDetail(route) {
      if (!route) {
        alert("ไม่พบข้อมูลการนัดหมาย");
        return;
      }

      this.$router.push(route);
    }
  },
  computed: {
    isDesktop() {
      return this.windowWidth > mlSize;
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
@import "~@/lib/scss/variables";

.appointment-history-wrapper {
  display: flex;
  flex-direction: column;
  height: auto;
  grid-gap: 16px;

  > .pack {
    display: flex;
    flex-direction: column;
    border: 1px solid #e6e6e6;
    border-radius: 8px;
    background-color: $white;
    padding: 12px 24px;

    > .name {
      font-size: $font-18;
      font-weight: bold;
    }

    > .quality {
      font-size: $font-16;
    }

    p {
      color: $black;
    }
  }

  .pack p {
    line-height: 1.6;
  }
}

.history {
  border: 2px solid #5175e1;
  border-radius: 8px;
  overflow: hidden;

  .title-wrapper {
    display: grid;
    grid-template-columns:
      calc(15% - 6px) calc(15% - 6px)
      calc(30% - 6px) calc(40% - 6px);
    grid-gap: 12px;
    padding: 8px 24px 0 24px;

    p {
      font-size: 14px;
      color: #808080;
    }
  }

  .billing-cycle {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 12px 8px 24px;
    border-top: 2px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
    background: #f7f7f7;

    > .arrow-wrapper {
      padding: 4px 12px;
      text-align: center;
      cursor: pointer;

      > .arrow {
        width: 8px;
        height: 8px;
        border: solid $black;
        border-width: 0 2px 2px 0;
        display: inline-block;
      }

      > .up {
        transform: rotate(-135deg);
        -webkit-transform: rotate(-135deg);
      }

      > .down {
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
      }
    }

    p {
      color: $black;
      font-size: 16px;
      font-weight: bold;
      flex-grow: 1;
    }
  }

  .item {
    display: flex;
    flex-direction: column;

    > .content-wrapper-false {
      display: grid;
      grid-template-columns:
        calc(15% - 6px) calc(15% - 6px)
        calc(30% - 6px) calc(40% - 6px);
      grid-gap: 12px;
      padding: 8px 24px 0 24px;

      p {
        font-size: $font-16;
      }
    }

    > .content-wrapper-true {
      align-items: center;
      display: grid;
      grid-template-columns: calc(15% - 6px) calc(60% - 6px) calc(25% - 6px);
      grid-gap: 12px;
      padding: 12px 24px;
      border-bottom: 1px solid #e6e6e6;

      p {
        font-size: $font-16;
      }
    }
  }
}

.status {
  height: fit-content;
  display: flex;
  flex-direction: row;
  align-items: center;

  > .bullet {
    width: 16px;
    height: 16px;
    border-radius: 50%;
  }

  p {
    color: $black;
    margin-left: 8px;
  }

  & .created {
    background-color: $secondary-color;
  }

  & .cancelled {
    background-color: $danger-color;
  }

  & .confirmed,
  & .wait_confirmed_service_complete {
    background-color: $warning-color;
  }

  & .provider_fulfilled {
    background-color: $success-dark-color;
  }

  & .fulfilled {
    background-color: $success-color;
  }
}

.time_created,
.time_confirmed,
.time_wait_confirmed_service_complete {
  color: $primary-color;
}

.button-wrapper-true {
  text-align: end;
}

.button-wrapper-false {
  padding: 0 16px 12px 0;
  text-align: end;
  border-bottom: 1px solid #e6e6e6;
}

.button {
  width: 90px;
  height: 34px;
  font-weight: bold;
  font-size: $font-14;
  border-radius: 8px;
}

.button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.primary {
  color: $white;
  background: $supplier-primary-color;
  border: none;

  &:hover:not(:disabled) {
    background: $supplier-primary-light-color;
  }
}

.secondary {
  color: $black;
  background: $white;
  border: 1px solid #d9d9d9;

  &:hover:not(:disabled) {
    background: #fafafa;
  }
}

@media (max-width: ($m-size - 1)) {
  .appointment-history-wrapper {
    > .pack {
      padding: 8px 16px;

      > .name {
        font-size: $font-18;
      }
    }
  }

  .history {
    .billing-cycle {
      padding: 8px 8px 8px 16px;

      > .arrow-wrapper {
        padding: 4px 8px;
      }
    }

    .item {
      > .content-wrapper {
        display: flex;
        flex-direction: column;
        padding: 12px 16px;

        > .appointment-no {
          font-size: $font-18;
          font-weight: bold;
        }

        p {
          font-size: $font-16;
        }
      }

      > .content-border {
        border-bottom: 1px solid #e6e6e6;
      }
    }
  }

  .status {
    padding-top: 12px;

    > .bullet {
      width: 14px;
      height: 14px;
    }
  }

  .appointment-title {
    font-size: $font-14;
    color: #808080;
    padding-top: 16px;
  }

  .note {
    margin-top: 16px;
    width: 100%;
    background-color: #f6f6f6;
    border-radius: 8px;
    padding: 8px 16px;

    > .title {
      font-size: $font-14;
      color: #808080;
    }

    p {
      font-size: $font-14;
    }
  }

  .button-wrapper-true {
    padding: 12px 0px 0px 0px;
  }

  .button-wrapper-false {
    padding: 4px 16px 16px 16px;
  }

  .button {
    width: 100%;
    height: 44px;
    font-size: $font-16;
  }
}

@media (min-width: $m-size) and (max-width: ($ml-size - 1)) {
  .appointment-history-wrapper {
    > .pack {
      padding: 8px 16px;

      > .name {
        font-size: $font-18;
      }
    }
  }

  .history {
    .billing-cycle {
      padding: 8px 8px 8px 16px;

      > .arrow-wrapper {
        padding: 4px 8px;
      }
    }

    .item {
      > .content-wrapper {
        display: flex;
        flex-direction: column;
        padding: 12px 16px;

        > .appointment-no {
          font-size: $font-18;
          font-weight: bold;
        }

        p {
          font-size: $font-16;
        }
      }

      > .content-border {
        border-bottom: 1px solid #e6e6e6;
      }
    }
  }

  .status {
    padding-top: 12px;

    > .bullet {
      width: 14px;
      height: 14px;
    }
  }

  .appointment-title {
    font-size: $font-14;
    color: #808080;
    padding-top: 16px;
  }

  .note {
    margin-top: 16px;
    width: 100%;
    background-color: #f6f6f6;
    border-radius: 8px;
    padding: 8px 16px;

    > .title {
      font-size: $font-14;
      color: #808080;
    }

    p {
      font-size: $font-14;
    }
  }

  .button-wrapper-true {
    padding: 12px 0px 0px 0px;
  }

  .button-wrapper-false {
    padding: 4px 16px 16px 16px;
  }

  .button {
    width: 100%;
    height: 44px;
    font-size: $font-16;
  }
}

@media (min-width: $ml-size) and (max-width: ($l-size - 1)) {
  .appointment-history-wrapper {
    > .pack {
      padding: 8px 16px;

      > .name {
        font-size: $font-16;
      }

      > .quality {
        font-size: $font-14;
      }
    }
  }

  .history {
    .title-wrapper {
      grid-template-columns:
        calc(15% - 4px) calc(18% - 4px)
        calc(30% - 4px) calc(37% - 4px);
      grid-gap: 8px;
      padding: 8px 16px 0 16px;
    }

    .billing-cycle {
      padding: 8px 8px 8px 16px;

      > .arrow-wrapper {
        padding: 4px 8px;
      }

      p {
        font-size: 14px;
      }
    }

    .item {
      > .content-wrapper-false {
        grid-template-columns:
          calc(15% - 4px) calc(18% - 4px)
          calc(30% - 4px) calc(37% - 4px);
        grid-gap: 8px;
        padding: 8px 16px 0 16px;

        p {
          font-size: $font-14;
        }
      }

      > .content-wrapper-true {
        grid-template-columns: calc(15% - 4px) calc(60% - 4px) calc(25% - 4px);
        grid-gap: 8px;
        padding: 8px 16px;
        border-bottom: 1px solid #e6e6e6;

        p {
          font-size: $font-14;
        }
      }
    }
  }

  .status {
    > .bullet {
      width: 12px;
      height: 12px;
    }

    p {
      margin-left: 4px;
    }
  }

  .button-wrapper-false {
    padding: 0 12px 8px 0;
  }

  .button {
    width: 80px;
    font-size: $font-12;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/other-web/supplier/components/AppointmentHistory.vue